import dayjs from "dayjs";
import ApiCall from "utils/ApiCall";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getAllNotificationMethods = async (hotelId?: string) => {
  try {
    return await ApiCall.get(
      `${process.env.REACT_APP_API}/notifications/availablemethods`
    );
  } catch (err) {
    throw err;
  }
};

const getWechatQrCode = async (
  bookingNumber: string,
  language: "en" | "tc" | "sc"
) => {
  try {
    return await ApiCall.post(
      `${process.env.REACT_APP_API}/notifications/waitforroom/wechat`,
      {
        bookingNumber,
        language,
      }
    );
  } catch (err) {
    throw err;
  }
};

export { getAllNotificationMethods, getWechatQrCode };
